import Script from 'next/script';
import { url } from 'config/env';

// utils
import { getServerVars } from 'utils/get-server-vars';

export const LEAD_MANAGEMENT_GTM_KEY = 'GTM-TLCTR6XJ';

// https://learn.microsoft.com/de-de/dynamics365/customer-insights/journeys/developer/realtime-marketing-form-client-side-extensibility#javascript-api
const CRM_FORM_SCRIPT_URL =
  'https://cxppusa1formui01cdnsa01-endpoint.azureedge.net/eur/FormLoader/FormLoader.bundle.js';

export default async function ScriptsServer({ globals, headersList, slug }) {
  const server = getServerVars(headersList);
  const gtmUrl = url(server?.gtmUrl || 'https://serversidegtm.prod.web.geberit.com');

  const currentUrl = `${server.baseUrl}/${slug}`;

  // due to the landingpage traumbad on ch should have a different GTM container we need to check the pathname
  // this can be removed in half a year
  const leadManagementLandingUrls = [
    'https://www.geberit.ch/landingpages-de/traumbad/',
    'https://www.geberit.ch/landingpages-de/traumbad-tools/',
    'https://www.geberit.ch/landingpages-de/traumbad-cashback/',
    'https://www.geberit.ch/landingpages-de/traumbad',
    'https://www.geberit.ch/landingpages-de/traumbad-tools',
    'https://www.geberit.ch/landingpages-de/traumbad-cashback',
    'https://preview-gdds-test-migration-country.dev.platform.web.geberit.com/landingpages-de/traumbad/',
    'https://preview-gdds-test-migration-country.dev.platform.web.geberit.com/landingpages-de/traumbad-tools/',
    'https://preview-gdds-test-migration-country.dev.platform.web.geberit.com/landingpages-de/traumbad-cashback/',
    'https://preview-gdds-test-migration-country.dev.platform.web.geberit.com/landingpages-de/traumbad',
    'https://preview-gdds-test-migration-country.dev.platform.web.geberit.com/landingpages-de/traumbad-tools',
    'https://preview-gdds-test-migration-country.dev.platform.web.geberit.com/landingpages-de/traumbad-cashback',
  ];

  const isLeadManagementLanding = leadManagementLandingUrls.includes(currentUrl ?? '');
  const gtmKey = isLeadManagementLanding ? LEAD_MANAGEMENT_GTM_KEY : globals?.gtmKey;

  return (
    <>
      <Script id="crm-forms-script" src={CRM_FORM_SCRIPT_URL} />
      {/* gtm */}
      <Script
        id="gtm"
        dangerouslySetInnerHTML={{
          __html: `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
                new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
                j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.setAttribute('gtm-script','true');j.src=
                '${gtmUrl}/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
                })(window,document,'script','dataLayer','${gtmKey}')`,
        }}
        data-gtm-key={gtmKey}
      />
      {/* gtm end */}
    </>
  );
}
